module.exports = __webpack_public_path__ + "static/media/Aalidhra16a1.13aeae7a.jpg";